module.exports = __webpack_public_path__ + "img/guided-meditation.aaf43ab2.png";